import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


const routes=[
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/home/home.vue')
      },
      {
        path: '/contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "about" */ '../views/link/link.vue')
      },
      {
        path: '/booking',
        name: 'booking',
        component: () => import(/* webpackChunkName: "about" */ '../views/booking/booking.vue')
      },
      {
        path: '/tattoo',
        name: 'tattoo',
        component: () => import(/* webpackChunkName: "about" */ '../views/tattoo/tattoo.vue')
      },
      {
        path: '/appointmentLocation',
        name: 'appointmentLocation',
        component: () => import(/* webpackChunkName: "about" */ '../views/appointmentLocation/appointmentLocation.vue')
      },
      {
        path: '/loginPage',
        name: 'LoginPage',
        component: () => import(/* webpackChunkName: "about" */ '../views/loginPage/LoginPage.vue')
      }
]

const router = new VueRouter({
    mode: 'hash',
    routes
  })


  // 路由守卫：拦截未登录用户访问受保护页面
  router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('auth_token');

    // 受保护页面列表，可扩展
    const protectedRoutes = ['/appointmentLocation'];

    if (protectedRoutes.includes(to.path)) {
      if (!token) {
        // 没有 token，重定向并提示
        alert('请先登录验证后再访问该页面');
        next('/loginPage');
      } else {
        next(); // 有 token，放行
      }
    } else {
      next(); // 非保护页面，直接放行
    }
  });
  
  export default router
  